import { useRef } from 'react';
import { IconButton } from '@/ui/components';
import { Icon } from '@/ui/Icon';

interface Props {
  value: string;
  onChange: (v: string) => void;
  onMenu?: (() => void) | undefined;
  placeholder?: string;
}

/** M3 search bar (pill shaped, leading menu button on compact screens). */
export function SearchBar({ value, onChange, onMenu, placeholder = 'Notizen durchsuchen' }: Props) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <div className="search-bar" role="search">
      {onMenu ? <IconButton icon="menu" label="Navigation öffnen" onClick={onMenu} /> : <Icon name="search" className="search-bar__icon" />}
      <input
        ref={input}
        type="search"
        value={value}
        placeholder={placeholder}
        aria-label="Suche"
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') onChange('');
        }}
      />
      {value && (
        <IconButton
          icon="close"
          label="Suche leeren"
          onClick={() => {
            onChange('');
            input.current?.focus();
          }}
        />
      )}
    </div>
  );
}
